import {UnitsType} from "@pg-design/range-module";

import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";
import {RangeOptionNameType} from "../types/RangeOptionNameType";

export const CreditOffersFiltersBaseData: ICalculatorOptions[] = [
    {
        title: "Cena nieruchomości",
        name: RangeOptionNameType.PRICE,
        values: {
            lower: 50000,
            upper: 8000000,
            init: 400000
        },
        uniteType: UnitsType.NUMBERS,
        valueType: CalculatorValueType.PRICE,
        step: 10000
    },
    {
        title: "Wkład własny",
        name: RangeOptionNameType.CONTRIBUTION,
        values: {
            lower: 10,
            upper: 90,
            init: 20
        },
        uniteType: UnitsType.PERCENTS,
        valueType: CalculatorValueType.CONTRIBUTION,
        step: 5
    },
    {
        title: "Okres kredytowania",
        name: RangeOptionNameType.PERIOD,
        values: {
            lower: 5,
            upper: 35,
            init: 30
        },
        step: 5,
        uniteType: UnitsType.YEARS,
        valueType: CalculatorValueType.PERIOD
    }
];
import {UnitsType} from "@pg-design/range-module";

import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";
import {RangeOptionNameType} from "../types/RangeOptionNameType";

export const CreditOffersFiltersBaseData: ICalculatorOptions[] = [
    {
        title: "Cena nieruchomości",
        name: RangeOptionNameType.PRICE,
        values: {
            lower: 50000,
            upper: 8000000,
            init: 400000
        },
        uniteType: UnitsType.NUMBERS,
        valueType: CalculatorValueType.PRICE,
        step: 10000
    },
    {
        title: "Wkład własny",
        name: RangeOptionNameType.CONTRIBUTION,
        values: {
            lower: 10,
            upper: 90,
            init: 20
        },
        uniteType: UnitsType.PERCENTS,
        valueType: CalculatorValueType.CONTRIBUTION,
        step: 5
    },
    {
        title: "Okres kredytowania",
        name: RangeOptionNameType.PERIOD,
        values: {
            lower: 5,
            upper: 35,
            init: 30
        },
        step: 5,
        uniteType: UnitsType.YEARS,
        valueType: CalculatorValueType.PERIOD
    }
];
